declare global {
    interface Window {
        calEmbedLoaded?: boolean;
    }
}

export interface CalBookingConfig {
    calLink: string;
    namespace: string;
    theme?: "light" | "dark";
    layout?: "month_view" | "week_view" | "column_view";
    hideEventTypeDetails?: boolean;
}

export function initCalBooking(config: CalBookingConfig) {
    if (typeof window === "undefined" || window.calEmbedLoaded) return;

    const {
        namespace,
        theme = "dark",
        layout = "month_view",
        hideEventTypeDetails = false,
    } = config;

    window.calEmbedLoaded = true;

    const script = document.createElement("script");
    script.innerHTML = `
        (function (C, A, L) {
          let p = function (a, ar) { a.q.push(ar); };
          let d = C.document;
          C.Cal = C.Cal || function () {
            let cal = C.Cal;
            let ar = arguments;
            if (!cal.loaded) {
              cal.ns = {};
              cal.q = cal.q || [];
              d.head.appendChild(d.createElement("script")).src = A;
              cal.loaded = true;
            }
            if (ar[0] === L) {
              const api = function () { p(api, arguments); };
              const activeNamespace = ar[1];
              api.q = api.q || [];
              if (typeof activeNamespace === "string") {
                cal.ns[activeNamespace] = cal.ns[activeNamespace] || api;
                p(cal.ns[activeNamespace], ar);
                p(cal, ["initNamespace", activeNamespace]);
              } else p(cal, ar);
              return;
            }
            p(cal, ar);
          };
        })(window, "https://app.cal.com/embed/embed.js", "init");

        Cal("init", "${namespace}", { origin: "https://app.cal.com" });

        Cal.ns["${namespace}"]("ui", {
          theme: "${theme}",
          cssVarsPerTheme: {
            light: { "cal-brand": "#181720" },
            dark: { "cal-brand": "#fafafa" },
          },
          hideEventTypeDetails: ${hideEventTypeDetails},
          layout: "${layout}",
        });
    `;

    document.head.appendChild(script);
}

export function getCalTriggerProps(config: CalBookingConfig) {
    const warm = () => initCalBooking(config);

    return {
        "data-cal-link": config.calLink,
        "data-cal-namespace": config.namespace,
        onMouseEnter: warm,
        onFocus: warm,
        onTouchStart: warm,
        onPointerDown: warm,
    };
}

export const defaultPixroBookingConfig: CalBookingConfig = {
    calLink: "pixroai/demo",
    namespace: "demo",
    theme: "dark",
    layout: "month_view",
    hideEventTypeDetails: false,
};
